export default function SectionHeading({ eyebrow, title, intro, light = false, align = "left" }) {
  return (
    <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`} data-testid="section-heading">
      {eyebrow && <p className={light ? "eyebrow-light" : "eyebrow"}>{eyebrow}</p>}
      <h2 className={`section-title mt-3 ${light ? "text-white" : ""}`}>{title}</h2>
      <span className={`gold-rule mt-5 ${align === "center" ? "mx-auto" : ""}`} aria-hidden="true" />
      {intro && (
        <p className={`mt-5 text-base leading-relaxed md:text-lg ${light ? "text-platinum" : "text-slate"}`}>
          {intro}
        </p>
      )}
    </div>
  );
}
